export const getValueFromCookie = (value) => {
  if (typeof value === "string") {
    const matches = document.cookie.match(
      new RegExp("(?:^|; )" + value.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)")
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }
};
